//Auth
export const LOGIN = 'LOGIN';

//Instructor
export const FETCH_LIVE_SCHEDULE = 'FETCH_LIVE_SCHEDULE';
export const FETCH_ONE_TO_ONE = 'FETCH_ONE_TO_ONE';
export const FETCH_ONE_TO_MANY = 'FETCH_ONE_TO_MANY';
export const LIVE_STATUS_CHANGE = 'LIVE_STATUS_CHANGE';
export const ACCESS_LOG = 'ACCESS_LOG';


